import { GuardedDeletionService, SpeciesService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpeciesCreateDto,
  SpeciesDto,
  SpeciesExcelDownloadDto,
  SpeciesUpdateDto,
} from '../proxy/general/dtos/species';
import { SPECIES_CONFIG, SPECIES_FIELDS } from './species.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-species',
  imports: [
      CommonModule,
      CardComponent,
      CardBodyComponent,
      CrudPage,
      GenericForm,
  ],
  providers: [ListService, SpeciesService, ConfirmationService],
  templateUrl: './species.html',
  styleUrl: './species.scss',
})
export class Species extends BaseHierarchicalCrudComponent<
  SpeciesDto,
  SpeciesCreateDto,
  SpeciesUpdateDto,
  SpeciesExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(SpeciesService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Species', ids),
  };
  config = SPECIES_CONFIG;
  fields = SPECIES_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpeciesDto): SpeciesUpdateDto {
    return {
      name: data.name,
      remsoftSpeciesGroupId: data.remsoftSpeciesGroupId,
      logisticsSpeciesGroupId: data.logisticsSpeciesGroupId,
      speciesGroupId: data.speciesGroupId,
      genusId: data.genusId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Species';
  }
}
